import actions from 'state/constants';

export const signUpForProductUpdates =
  ({ origination, emailAddress, variantSku, pdpSignupFlow }) =>
  async dispatch => {
    dispatch({
      type: actions.SIGN_UP_PRODUCT_UPDATES_REQUEST,
      payload: { emailAddress, variantSku, pdpSignupFlow },
      meta: { origination },
    });
  };

export const signUpForNewsletter =
  ({ emailAddress, acceptsMarketing, origination, pdpSignupFlow, purpose, ...props }) =>
  async dispatch => {
    dispatch({
      type: actions.SIGN_UP_NEWSLETTER_REQUEST,
      payload: { emailAddress, acceptsMarketing, pdpSignupFlow },
      meta: { origination, purpose, ...props },
    });
  };

export default signUpForProductUpdates;
